import * as React from 'react'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import * as st from './bannerPromo.module.scss'

export interface IBannerPromoProps {
  imagePath: string,
  imageAlt: string,
  imageLink?: WpsRuntime.atv.wps.ImageLink,
}

export const BannerPromo = ({ imagePath, imageLink, imageAlt }: IBannerPromoProps) =>
  imagePath && imageLink ? (
    <div className={st.topBanner}>
      <div className={st.superTcgDetail}>
        <a href={imageLink.href} aria-label={imageLink.ariaLabel}>
          <img src={imagePath} alt={imageAlt}/>
        </a>
      </div>
    </div>
  ) : null